type QueryParameterValue = string | number | null

export function replaceProductUrlParameters(
	parameters: Record<string, QueryParameterValue>,
	pathname?: string
): void {
	const currentUrl = new URL(window.location.href)
	const nextUrl = new URL(pathname ?? currentUrl.pathname, currentUrl.origin)
	nextUrl.search = currentUrl.search
	nextUrl.hash = currentUrl.hash

	Object.entries(parameters).forEach(([name, value]) => {
		if (value === null) {
			nextUrl.searchParams.delete(name)
			return
		}
		nextUrl.searchParams.set(name, `${value}`)
	})

	window.history.replaceState(
		window.history.state,
		'',
		`${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`
	)
}
